import { useEffect, useState } from 'react';
function useMedia(queries, values, defaultValue) {
    const mediaQueryLists = queries.map((q) => window.matchMedia(q));
    const getValue = () => {
        const index = mediaQueryLists.findIndex((mql) => mql.matches);
        return (values === null || values === void 0 ? void 0 : values[index]) || defaultValue;
    };
    const [value, setValue] = useState(getValue);
    useEffect(() => {
        const handler = () => setValue(getValue);
        mediaQueryLists.forEach((mql) => {
            mql.addEventListener('change', handler);
        });
        return () => {
            mediaQueryLists.forEach((mql) => mql.removeEventListener('change', handler));
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return value;
}
export default useMedia;
//# sourceMappingURL=useMedia.js.map